import * as types from '../Types';

export const ADD_EMPLOYEE_API = 'admin/employees';
export const REMOVE_EMPLOYEE_API = 'employees/rewards?id=';
export const CATEGORY_API = 'admin/reward-categories';
export const BULK_ADD_EMPLOYEES_VALIDATE_API = '/admin/bulk-upload/validate';
export const BULK_ADD_EMPLOYEES_CONFIRM_API = '/admin/bulk-upload/commit';
export const FETCH_ROLE_PERMISSIONS_API = 'superadmin/roles';
export const FETCH_PERMISSIONS_API = 'superadmin/permissions';
export const ADD_ROLE_API = 'superadmin/roles';
export const UPDATE_ROLE_API = 'superadmin/roles';
// ESLint and Template strings don't work too well

export function addEmployee(data) {
  return {
    types: [types.ADD_EMPLOYEE, types.ADD_EMPLOYEE_SUCCESS, types.ADD_EMPLOYEE_FAILURE],
    promise: client => client.post(ADD_EMPLOYEE_API, data)
  };
}

export function bulkAddEmployees(formData) {
  return {
    types: [
      types.BULK_ADD_EMPLOYEES,
      types.BULK_ADD_EMPLOYEES_SUCCESS,
      types.BULK_ADD_EMPLOYEES_FAILURE
    ],
    promise: client => client.post(BULK_ADD_EMPLOYEES_VALIDATE_API, formData)
  };
}

export function commitBulkUpload(data) {
  return {
    types: [
      types.BULK_ADD_EMPLOYEES,
      types.BULK_ADD_EMPLOYEES_SUCCESS,
      types.BULK_ADD_EMPLOYEES_FAILURE
    ],
    promise: client => client.post(BULK_ADD_EMPLOYEES_CONFIRM_API, data)
  };
}

export function updateEmployee(data, currentEmployeeId) {
  return {
    types: [types.UPDATE_EMPLOYEE, types.UPDATE_EMPLOYEE_SUCCESS, types.UPDATE_EMPLOYEE_FAILURE],
    promise: client => client.put(`${ADD_EMPLOYEE_API}/${currentEmployeeId}`, data)
  };
}

export function removeEmployee(id) {
  return {
    types: [types.REMOVE_EMPLOYEE, types.REMOVE_EMPLOYEE_SUCCESS, types.REMOVE_EMPLOYEE_FAILURE],
    promise: client => client.delete(`${ADD_EMPLOYEE_API}/${id}`)
  };
}

export function addCategory(data) {
  return {
    types: [types.ADD_CATEGORY, types.ADD_CATEGORY_SUCCESS, types.ADD_CATEGORY_FAILURE],
    promise: client => client.post(CATEGORY_API, data)
  };
}

export function updateCategory(data, currentCategoryId) {
  return {
    types: [types.UPDATE_CATEGORY, types.UPDATE_CATEGORY_SUCCESS, types.UPDATE_CATEGORY_FAILURE],
    promise: client => client.put(`${CATEGORY_API}/${currentCategoryId}`, data)
  };
}

export function deleteCategory(id) {
  return {
    types: [types.REMOVE_CATEGORY, types.REMOVE_CATEGORY_SUCCESS, types.REMOVE_CATEGORY_FAILURE],
    promise: client => client.delete(`${CATEGORY_API}/${id}`)
  };
}

export function fetchRolePermissions() {
  return {
    types: [
      types.FETCH_ROLE_PERMISSIONS,
      types.FETCH_ROLE_PERMISSIONS_SUCCESS,
      types.FETCH_ROLE_PERMISSIONS_FAILURE
    ],
    promise: client =>
      client.get(FETCH_ROLE_PERMISSIONS_API, {
        baseURL: (process.env.REACT_APP_API_BASE_URL || '').replace('v1', 'v2')
      })
  };
}

export function fetchPermissions() {
  return {
    types: [
      types.FETCH_PERMISSIONS,
      types.FETCH_PERMISSIONS_SUCCESS,
      types.FETCH_PERMISSIONS_FAILURE
    ],
    promise: client =>
      client.get(FETCH_PERMISSIONS_API, {
        baseURL: (process.env.REACT_APP_API_BASE_URL || '').replace('v1', 'v2')
      })
  };
}

export function addRole(data) {
  return {
    types: [types.ADD_ROLE, types.ADD_ROLE_SUCCESS, types.ADD_ROLE_FAILURE],
    promise: client =>
      client.post(ADD_ROLE_API, data, {
        baseURL: (process.env.REACT_APP_API_BASE_URL || '').replace('v1', 'v2')
      })
  };
}

export function updateRole(data) {
  return {
    types: [types.UPDATE_ROLE, types.UPDATE_ROLE_SUCCESS, types.UPDATE_ROLE_FAILURE],
    promise: client =>
      client.patch(FETCH_ROLE_PERMISSIONS_API, data, {
        baseURL: (process.env.REACT_APP_API_BASE_URL || '').replace('v1', 'v2')
      })
  };
}

export function deleteRole(roleId) {
  return {
    types: [types.DELETE_ROLE, types.DELETE_ROLE_SUCCESS, types.DELETE_ROLE_FAILURE],
    promise: client =>
      client.delete(`${FETCH_ROLE_PERMISSIONS_API}/${roleId}`, {
        baseURL: (process.env.REACT_APP_API_BASE_URL || '').replace('v1', 'v2')
      }),
    roleId
  };
}

export function fetchEmployees() {
  return {
    types: [types.FETCH_EMPLOYEES, types.FETCH_EMPLOYEES_SUCCESS, types.FETCH_EMPLOYEES_FAILURE],
    promise: client => client.get(`${ADD_EMPLOYEE_API}/identities/all`)
  };
}

export function downloadRewardsReport(params) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) searchParams.append(key, value);
  });

  return {
    types: [types.DOWNLOAD_REPORT, types.DOWNLOAD_REPORT_SUCCESS, types.DOWNLOAD_REPORT_FAILURE],
    promise: client =>
      client.get(`/rewards/data?${searchParams.toString()}`, {}, { responseType: 'blob' })
  };
}

export const SYNC_ZOHO_API = 'admin/sync/zoho';
export function syncZoho(days = 1) {
  return {
    types: [types.SYNC_ZOHO, types.SYNC_ZOHO_SUCCESS, types.SYNC_ZOHO_FAILURE],
    promise: client => client.post(`${SYNC_ZOHO_API}?days=${days}`, null)
  };
}
